// Central user-facing brand & contact defaults (fallbacks only).
// Does not affect API endpoints, auth, or database values.

export const BRAND_NAME = 'Admission Bazaar';
export const BRAND_TAGLINE = 'Dream • Discover • Succeed';
export const APP_NAME = 'Admission Bazaar';
export const SITE_NAME = 'Admission Bazaar';
export const META_TITLE = 'Admission Bazaar | Dream • Discover • Succeed';
export const META_DESCRIPTION =
  'Admission Bazaar is a modern admission platform helping students discover colleges, courses, and achieve their academic goals.';

export const SUPPORT_EMAIL = 'Admissionsbazaar@gmail.com';
export const SUPPORT_PHONE_DISPLAY = '+91 9479469454';
export const SUPPORT_PHONE_TEL = '+919479469454';

export {
  API_BASE_URL,
  FRONTEND_URL,
  SITE_URL,
  ADMIN_PORTAL_URL,
  MEDIA_BASE_URL,
} from './apiConfig';
